// extracted by mini-css-extract-plugin
module.exports = {"skeletonOption":"QuestionsSkeleton_skeletonOption__11Vtu"};